export const SHOW_CART = "SHOW_CART";
export const HIDE_CART = "HIDE_CART";
export const CREATE_CHECKOUT_REQUEST = "CREATE_CHECKOUT_REQUEST";
export const CREATE_CHECKOUT_REQUEST_FAILURE =
  "CREATE_CHECKOUT_REQUEST_FAILURE";
export const CREATE_CHECKOUT_RECEIVE = "CREATE_CHECKOUT_RECEIVE";
export const UPDATE_CHECKOUT_REQUEST = "UPDATE_CHECKOUT_REQUEST";
export const UPDATE_CHECKOUT_REQUEST_FAILURE =
  "UPDATE_CHECKOUT_REQUEST_FAILURE";
export const UPDATE_CHECKOUT_RECEIVE = "UPDATE_CHECKOUT_RECEIVE";
export const FETCH_CHECKOUT_REQUEST = "FETCH_CHECKOUT_REQUEST";
export const FETCH_CHECKOUT_REQUEST_FAILURE = "FETCH_CHECKOUT_REQUEST_FAILURE";
export const FETCH_CHECKOUT_RECEIVE = "FETCH_CHECKOUT_RECEIVE";
export const ADD_TO_CART_REQUEST = "ADD_TO_CART_REQUEST";
export const ADD_TO_CART_REQUEST_FAILURE = "ADD_TO_CART_REQUEST_FAILURE";
export const ADD_TO_CART_RECEIVE = "ADD_TO_CART_RECEIVE";
export const REMOVE_FROM_CART_REQUEST = "REMOVE_FROM_CART_REQUEST";
export const REMOVE_FROM_CART_REQUEST_FAILURE =
  "REMOVE_FROM_CART_REQUEST_FAILURE";
export const REMOVE_FROM_CART_RECEIVE = "REMOVE_FROM_CART_RECEIVE";
export const UPDATE_QUANTITY_REQUEST = "UPDATE_QUANTITY_REQUEST";
export const UPDATE_QUANTITY_REQUEST_FAILURE =
  "UPDATE_QUANTITY_REQUEST_FAILURE";
export const UPDATE_QUANTITY_RECEIVE = "UPDATE_QUANTITY_RECEIVE";
export const START_QUANTITY_UPDATE = "START_QUANTITY_UPDATE";
export const COMPLETE_QUANTITY_UPDATE = "COMPLETE_QUANTITY_UPDATE";
export const STALE_CHECKOUT_ID = "STALE_CHECKOUT_ID";
export const FETCH_COLLECTION_REQUEST = "FETCH_COLLECTION_REQUEST";
export const FETCH_COLLECTION_REQUEST_FAILURE =
  "FETCH_COLLECTION_REQUEST_FAILURE";
export const FETCH_COLLECTION_RECEIVE = "FETCH_COLLECTION_RECEIVE";
export const FETCH_SLEEP_GOAL_SUB_COLLECTIONS_REQUEST =
  "FETCH_SLEEP_GOAL_SUB_COLLECTIONS_REQUEST";
export const FETCH_SLEEP_GOAL_SUB_COLLECTIONS_FAILURE =
  "FETCH_SLEEP_GOAL_SUB_COLLECTIONS_FAILURE";
export const FETCH_SLEEP_GOAL_SUB_COLLECTIONS_RECEIVE =
  "FETCH_SLEEP_GOAL_SUB_COLLECTIONS_RECEIVE";
export const APPLY_DISCOUNT_CODE_REQUEST = "APPLY_DISCOUNT_CODE_REQUEST";
export const APPLY_DISCOUNT_CODE_RECEIVE = "APPLY_DISCOUNT_CODE_RECEIVE";
export const APPLY_DISCOUNT_CODE_FAILURE = "APPLY_DISCOUNT_CODE_FAILURE";
export const INVALID_DISCOUNT_CODE_APPLIED = "INVALID_DISCOUNT_CODE_APPLIED";
export const REMOVE_DISCOUNT_CODE_REQUEST = "REMOVE_DISCOUNT_CODE_REQUEST";
export const REMOVE_DISCOUNT_CODE_RECEIVE = "REMOVE_DISCOUNT_CODE_RECEIVE";
export const REMOVE_DISCOUNT_CODE_FAILURE = "REMOVE_DISCOUNT_CODE_FAILURE";
export const ADD_PRODUCT_AS_GIFT_WITH_PURCHASE_REQUEST =
  "ADD_PRODUCT_AS_GIFT_WITH_PURCHASE_REQUEST";
export const ADD_PRODUCT_AS_GIFT_WITH_PURCHASE_RECEIVE =
  "ADD_PRODUCT_AS_GIFT_WITH_PURCHASE_RECEIVE";
export const ADD_PRODUCT_AS_GIFT_WITH_PURCHASE_FAILURE =
  "ADD_PRODUCT_AS_GIFT_WITH_PURCHASE_FAILURE";
export const REMOVE_PRODUCT_AS_GIFT_WITH_PURCHASE_REQUEST =
  "REMOVE_PRODUCT_AS_GIFT_WITH_PURCHASE_REQUEST";
export const REMOVE_PRODUCT_AS_GIFT_WITH_PURCHASE_RECEIVE =
  "REMOVE_PRODUCT_AS_GIFT_WITH_PURCHASE_RECEIVE";
export const REMOVE_PRODUCT_AS_GIFT_WITH_PURCHASE_FAILURE =
  "REMOVE_PRODUCT_AS_GIFT_WITH_PURCHASE_FAILURE";

export const UPDATE_LINE_ITEMS_REQUEST = "UPDATE_LINE_ITEMS_REQUEST";
export const UPDATE_LINE_ITEMS_RECEIVE = "UPDATE_LINE_ITEMS_RECEIVE";
export const UPDATE_LINE_ITEMS_FAILURE = "UPDATE_LINE_ITEMS_FAILURE";

export const CHECKOUT = "CHECKOUT";
